const month = {
	data: [
		{ id: 1, type: 'month', attributes: { abbr: 'Jan', name: 'January', number: '01' } },
		{ id: 2, type: 'month', attributes: { abbr: 'Feb', name: 'February', number: '02' } },
		{ id: 3, type: 'month', attributes: { abbr: 'Mar', name: 'March', number: '03' } },
		{ id: 4, type: 'month', attributes: { abbr: 'Apr', name: 'April', number: '04' } },
		{ id: 5, type: 'month', attributes: { abbr: 'May', name: 'May', number: '05' } },
		{ id: 6, type: 'month', attributes: { abbr: 'Jun', name: 'June', number: '06' } },
		{ id: 7, type: 'month', attributes: { abbr: 'Jul', name: 'July', number: '07' } },
		{ id: 8, type: 'month', attributes: { abbr: 'Aug', name: 'August', number: '08' } },
		{ id: 9, type: 'month', attributes: { abbr: 'Sep', name: 'September', number: '09' } },
		{ id: 10, type: 'month', attributes: { abbr: 'Oct', name: 'October', number: '10' } },
		{ id: 11, type: 'month', attributes: { abbr: 'Nov', name: 'November', number: '11' } },
		{ id: 12, type: 'month', attributes: { abbr: 'Dec', name: 'December', number: '12' } }
	]
}

export { month as default }
